import { TableWithFeatures } from '@/affiliate-dashboard/components/base/table-with-features';
import {
  CommissionStatus,
  type CommissionResponseExtraFragment,
} from '@/affiliate-dashboard/graphql';
import { PageHeading } from '@/components/base/page-heading';
import { cn } from '@/utils';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIntl } from 'react-intl';
import { defaultColumns } from './columns';
import { OrderDetailDrawer } from './order-detail-drawer';

export function CommissionsTable({
  data,
  handlePageChange,
  totalPages,
  currentPage,
}: {
  data: (CommissionResponseExtraFragment | null)[];
  handlePageChange: (page: number) => void;
  totalPages: number;
  currentPage: number;
}): JSX.Element {
  const intl = useIntl();
  const { t } = useTranslation();
  const columns = useMemo(() => defaultColumns(intl, { t }), [intl, t]);
  const [orderId, setOrderId] = useState<string | null>(null);
  const [selectedRow, setAelectedRow] =
    useState<CommissionResponseExtraFragment | null>(null);

  //   const handleSearch = (query: string) => {
  //     const filtered = data.filter((item) => {
  //       if (!item) return false;
  //       return Object.values(item).some((value) => {
  //         if (value === null || typeof value === 'object') {
  //           return false;
  //         }

  //         return value.toString().toLowerCase().includes(query.toLowerCase());
  //       });
  //     });

  //     return filtered;
  //   };

  return (
    <TableWithFeatures
      data={data}
      columns={columns}
      itemsPerPage={2}
      searchPlaceholder="Search commissions..."
      onPageChange={handlePageChange}
      totalPages={totalPages}
      page={currentPage}
      rowClick={(row) => {
        setOrderId(row?.order?.id ?? null);
        setAelectedRow(row);
      }}
      rowClassName={(row) => {
        return cn('cursor-pointer', {
          'opacity-40': row?.status === CommissionStatus.Locked,
        });
      }}
    >
      <PageHeading>{t('commissions.overview.commissions')}</PageHeading>
      <OrderDetailDrawer
        onClose={() => {
          setOrderId(null);
        }}
        orderId={orderId ?? ''}
        isOpen={Boolean(orderId)}
        commissionData={selectedRow}
      />
    </TableWithFeatures>
  );
}
